export const CHANGE_ALEX_STATE = 'CHANGE_ALEX_STATE';

export const changeAlexState = payload => ({
  type: CHANGE_ALEX_STATE,
  payload,
});
